namespace Matrix.Administration {
    export interface RolePermissionListRequest extends Serenity.ServiceRequest {
        RoleName?: string;
    }
}
